import { Component, OnInit } from '@angular/core';

import { BehaviorSubject, map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { BookingAppState, SelectionPhase } from '@fcom/common/interfaces/booking';
import { BoundType } from '@fcom/dapi/interfaces';
import { ModalButtons, TabLayoutType } from '@fcom/ui-components';
import { BookingService } from '@fcom/booking/services';
import { FinnairCart } from '@fcom/dapi/api/models';
import { ElementActions, ElementTypes, GaContext } from '@fcom/common/interfaces';
import { GtmService } from '@fcom/common/gtm';
import { BOOKING_STEPS } from '@fcom/common/config/booking-config';
import { cartData } from '@fcom/booking/store/selectors/cart.selector';

interface TicketSummaryModalState {
  open: boolean;
  boundType: BoundType;
}

@Component({
  selector: 'fin-pax-flight-review-summary',
  templateUrl: './pax-flight-review-summary.component.html',
})
export class PaxFlightReviewSummaryComponent implements OnInit {
  public readonly BoundType = BoundType;
  readonly SelectionPhase = SelectionPhase;

  readonly selectionPhase$: BehaviorSubject<SelectionPhase> = new BehaviorSubject<SelectionPhase>(
    SelectionPhase.OUTBOUND
  );

  ModalButtons = ModalButtons;
  TabLayoutType = TabLayoutType;

  currentOffer$: Observable<FinnairCart>;

  ticketSummaryModal: TicketSummaryModalState = {
    open: false,
    boundType: BoundType.outbound,
  };
  isOneWay$: Observable<boolean>;

  constructor(
    private bookingService: BookingService,
    private store$: Store<BookingAppState>,
    private gtmService: GtmService
  ) {}

  ngOnInit(): void {
    this.currentOffer$ = this.store$.pipe(cartData());
    this.isOneWay$ = this.currentOffer$.pipe(map((details) => details?.bounds.length === 1));
  }

  showTicketSummaryModal(boundType: BoundType): void {
    this.ticketSummaryModal = { open: true, boundType };

    this.gtmService.trackElement(
      'pax-details-flight-review::view-flight-details',
      GaContext.PAX_DETAILS_FLIGHT_REVIEW,
      ElementTypes.LINK,
      undefined,
      ElementActions.CLICK
    );
  }

  closeModals(): void {
    this.ticketSummaryModal = { open: false, boundType: BoundType.outbound };
  }

  activateSelectionPhase(selectionPhase: SelectionPhase): void {
    this.selectionPhase$.next(selectionPhase);
    this.bookingService.setStep({ step: BOOKING_STEPS.FLIGHT_SELECTION });
  }
}
